export const BUG_REPORT_MODAL_FILES_EXTENSIONS =
  '.xlsx, .xls, .jpg, .png, .jpeg, .pdf, .doc, .docx, .txt';
export const EXPENSES_MODAL_FILES_EXTENSIONS = '.jpeg, .jpg, .png, .gif, .pdf';
